import { store, app } from "..";
import { hashHistory } from "react-router";
const getEstQuery = newinfo => {
  console.log("new info", newinfo);
  return app
    .service("tminvparams")
    .get(newinfo.pminfo.custnumber)
    .then(results => {
      window.localStorage.setItem("estimateInfo", JSON.stringify(newinfo))
      window.localStorage.setItem("newEstimate", JSON.stringify({
        ...newinfo, tasks: [],
        deliverables: []
      }))
      console.log("tminvparams", results);
      window.localStorage.setItem("tminvparams", JSON.stringify(results))
      hashHistory.push({
        pathname: "/create-estimate",
        state: { estimateinfo: newinfo, tminvparams: results }
      });
    })
    .catch(err => {
      if (err.code === 404) {
        hashHistory.push({
          pathname: "/create-estimate",
          state: {
            estimateinfo: newinfo,
            tminvparams: {
              custnumber: newinfo.pminfo.custnumber,
              nextestnumber: 1,
              nexttmnumber: 1,
              nextwonumber: genCustWod(newinfo.pminfo.custnumber)
            }
          }
        });
      }
    });
};

const genCustWod = custnumber => {
  console.log("getcustwod", custnumber);
  custnumber -= 1;
  var wod = store
    .getState()
    .workorders.derivitives.find(w => w.custnumber == custnumber);
  let custnum = parseInt(wod.workOrderNbr.slice(0, 2));
  custnum += 1;
  return custnum + "-" + "0001";
};

export default getEstQuery;



// WEBPACK FOOTER //
// ./src/services/estquery.js